export default __webpack_public_path__ + "static/banner_mrcs-77ba186579703d1749cacdc1b7fba102.jpg";